/**
 * Product Selector V2
 * Tab switching, add-to-cart, quantity controls, unlock-more-entries.
 * All scoped to .ps-v2 elements.
 */
(function () {
  'use strict';

  /* ---------- QUERY PARAMS & COOKIES ---------- */
  const searchParams = new URLSearchParams(window.location.search);

  function createFacebookClickId() {
    const fbId = 'fb.1.' + Date.now() + '.' + searchParams.get('fbclid');
    Cookies.set('_fbc', fbId, {
      expires: 7,
      domain: window.location.hostname.replace('store.', ''),
    });
    return fbId;
  }

  function createFacebookPixel() {
    const facebookPixelId = 'fb.1.' + Date.now() + '.' + Math.floor(Math.random() * Date.now());
    Cookies.set('_fbp', facebookPixelId, {
      expires: 7,
      domain: window.location.hostname.replace('store.', ''),
    });
    return facebookPixelId;
  }

  const facebookClickId = searchParams.has('fbclid')
    ? createFacebookClickId()
    : (typeof Cookies !== 'undefined' ? Cookies.get('_fbc') : undefined);

  const ttClickId = searchParams.get('ttclid') || (typeof Cookies !== 'undefined' ? Cookies.get('ttclid') : undefined);
  const ttPixelId = typeof Cookies !== 'undefined' ? Cookies.get('_ttp') : undefined;

  var attributes = {};
  if (facebookClickId) attributes.fb_click_id = facebookClickId;
  attributes.fb_pixel_id = (typeof Cookies !== 'undefined' ? Cookies.get('_fbp') : null) || createFacebookPixel();
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    attributes.custom_id = crypto.randomUUID();
    attributes.purchase_event_id = crypto.randomUUID();
    attributes.checkout_event_id = crypto.randomUUID();
    attributes.cart_event_id = crypto.randomUUID();
  }
  attributes.origin_url = window.location.href;
  if (ttClickId) attributes.tiktok_click_id = ttClickId;
  if (ttPixelId) attributes.tiktok_pixel_id = ttPixelId;
  ['webview', 'source', 'referral', 'challenge', 'action', 'product'].forEach(function (key) {
    if (searchParams.has(key)) attributes[key] = searchParams.get(key);
  });

/* ---------- CART HELPERS ---------- */
  function updateCart() {
    var body = { attributes: attributes };
    if (searchParams.has('referral')) body.discount = searchParams.get('referral');
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).catch(function (err) { console.error('V2 updateCart error:', err); });
  }

  function checkKlaviyoState() {
    if (searchParams.get('utm_source') === 'Klaviyo') {
      sessionStorage.setItem('isKlaviyo', 'true');
    }
  }

  function checkHeaderFooter() {
    if (searchParams.get('webview') === 'app') {
      var header = document.querySelector('.header-wrapper');
      var footer = document.querySelector('.footer');
      if (header) header.style.display = 'none';
      if (footer) footer.style.display = 'none';
    }
  }

  /* ---------- ADD TO CART ---------- */
  var isAddingToCart = false;
  function addToCartV2(el, quantity) {
    if (isAddingToCart) return;
    isAddingToCart = true;

    var variantId = Number(el.dataset.variant);
    var subscriptionId = el.dataset.subscription;

    if (!variantId) { console.error('V2: no variant id on element'); isAddingToCart = false; return; }

    // Premium buying animation
    el.classList.add('ps-v2-buying');
    spawnParticles(el);
    playBuySound();
    if (navigator.vibrate) navigator.vibrate([15, 40, 25]);

    // Button text swap → "ACTIVATED" / "ACTIVADO"
    var isSpanishPage = window.location.pathname.indexOf('fb-es') >= 0 || window.location.pathname.indexOf('fbpes') >= 0;
    var activatedText = isSpanishPage ? 'ACTIVADO' : 'ACTIVATED';
    var btn = el.querySelector('.ps-v2-card__btn') || el.querySelector('.ps-v2-row__btn') || el.querySelector('.ps-v2-single__buy-btn');
    if (!btn && el.classList.contains('ps-v2-buy-single')) btn = el;
    if (btn && !btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = activatedText;
    }

    // Entry count number flash
    var entriesEl = el.querySelector('.ps-v2-card__new-entries') || el.querySelector('.ps-v2-row__entries') || el.querySelector('.ps-v2-single__entries-amount');
    if (!entriesEl) {
      var singleCard = el.closest('.ps-v2-single-card');
      if (singleCard) entriesEl = singleCard.querySelector('.ps-v2-single__entries-amount');
    }
    if (entriesEl) {
      entriesEl.classList.add('ps-v2-entries-flash');
      entriesEl.addEventListener('animationend', function () {
        entriesEl.classList.remove('ps-v2-entries-flash');
      }, { once: true });
    }

    var qty = quantity || 1;
    var data;
    if (subscriptionId) {
      data = {
        quantity: 1,
        selling_plan: Number(subscriptionId),
        id: variantId,
      };
    } else {
      data = {
        quantity: qty,
        id: variantId,
      };
    }

    // Add item → redirect to checkout immediately
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(function (res) { return res.json(); })
      .then(function (response) {
        if (!response.status) {
          // Fire-and-forget: notify cart subscribers
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-selector-v2',
              productVariantId: data.id,
              cartData: response,
            });
          }
        }

        // Redirect immediately — animation stays alive until page navigates
        window.location.href = '/checkout';
      }).catch(function (err) {
        console.error('V2 addToCart error:', err);
      });
  }

  /* ---------- TABS ---------- */
  var tabs = document.querySelectorAll('.ps-v2-tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function (e) {
      e.stopPropagation();
      var clickedId = tab.id; // "ps-v2-tab-membership" or "ps-v2-tab-one-time"
      var isMemb = clickedId === 'ps-v2-tab-membership';
      var activeGroup = isMemb ? 'membership' : 'one-time';

      // Toggle tab active state
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');

      // Toggle groups visibility
      var container = tab.closest('.ps-v2');
      if (!container) return;
      var groups = container.querySelectorAll('.ps-v2-group');
      groups.forEach(function (g) {
        if (g.id === 'ps-v2-group-' + activeGroup) {
          g.classList.add('active');
        } else {
          g.classList.remove('active');
        }
      });

      // Toggle prize groups (if present on the page from the section wrapper)
      togglePrizeGroups(activeGroup);
    });
  });

  /* ---------- FREQUENCY SUB-TABS ---------- */
  var freqTabs = document.querySelectorAll('.ps-v2-freq-tab');
  freqTabs.forEach(function (ftab) {
    ftab.addEventListener('click', function (e) {
      e.stopPropagation();
      var isYearly = ftab.id === 'ps-v2-freq-tab-yearly';
      var activeFreq = isYearly ? 'yearly' : 'monthly';

      var membershipGroup = ftab.closest('.ps-v2-group');
      if (!membershipGroup) return;

      membershipGroup.querySelectorAll('.ps-v2-freq-tab').forEach(function (t) {
        t.classList.remove('active');
      });
      ftab.classList.add('active');

      membershipGroup.querySelectorAll('.ps-v2-freq-group').forEach(function (fg) {
        if (fg.id === 'ps-v2-freq-group-' + activeFreq) {
          fg.classList.add('active');
        } else {
          fg.classList.remove('active');
        }
      });
    });
  });

  function togglePrizeGroups(activeTab) {
    var prizeGroups = document.querySelectorAll('.prizes__group[data-type]');
    prizeGroups.forEach(function (group) {
      var groupType = group.getAttribute('data-type');
      if (groupType === activeTab) {
        group.style.display = 'flex';
      } else {
        group.style.display = 'none';
      }
    });
  }

  /* ---------- CARD CLICK → ADD TO CART ---------- */
  var allCards = document.querySelectorAll('.ps-v2-card');
  allCards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      e.preventDefault();
      if (card.classList.contains('sold-out')) return;
      addToCartV2(card, 1);
    });
  });

  /* ---------- CARD BUY NOW BUTTON → ADD TO CART ---------- */
  var cardBtns = document.querySelectorAll('.ps-v2-card__btn');
  cardBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var card = btn.closest('.ps-v2-card');
      if (!card || card.classList.contains('sold-out')) return;
      addToCartV2(card, 1);
    });
  });

  /* ---------- ROW CLICK → ADD TO CART ---------- */
  var rowItems = document.querySelectorAll('.ps-v2-row');
  rowItems.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      if (item.classList.contains('sold-out')) return;
      addToCartV2(item, 1);
    });
  });

  /* ---------- TABLE ROW BUY BUTTON ---------- */
  var rowBtns = document.querySelectorAll('.ps-v2-row__btn');
  rowBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var row = btn.closest('.ps-v2-row');
      if (!row || row.classList.contains('sold-out')) return;
      addToCartV2(row, 1);
    });
  });

  /* ---------- SINGLE TICKET – QUANTITY CONTROLS ---------- */
  var qtyInput = document.querySelector('.ps-v2-qty-input');
  var minusBtn = document.querySelector('.ps-v2-qty-minus');
  var plusBtn = document.querySelector('.ps-v2-qty-plus');
  var qtyWarning = document.getElementById('ps-v2-qty-warning');
  var singleQuantity = 1;

  function showMaxWarning() {
    if (!qtyWarning) return;
    qtyWarning.style.opacity = '1';
    qtyWarning.style.display = 'block';
    if (qtyInput) qtyInput.classList.add('ps-v2-shake');
    setTimeout(function () {
      qtyWarning.style.opacity = '0';
      qtyWarning.style.display = 'none';
      if (qtyInput) qtyInput.classList.remove('ps-v2-shake');
    }, 4000);
  }

  function enforceMax(val) {
    if (val > 30) { showMaxWarning(); return 30; }
    return val;
  }

  // Cache base values from the single card on first load
  var singleBasePrice = 0;
  var singleBaseEntries = 1;
  (function initSingleBase() {
    var card = document.querySelector('.ps-v2-single-card');
    if (!card) return;
    var priceEl = card.querySelector('.ps-v2-single__price');
    if (priceEl) {
      var raw = priceEl.textContent.replace(/[^0-9.]/g, '');
      singleBasePrice = parseFloat(raw) || 0;
    }
    var entriesEl = card.querySelector('.ps-v2-single__entries-amount');
    if (entriesEl) singleBaseEntries = parseInt(entriesEl.textContent, 10) || 1;
  })();

  function updateSingleDisplay() {
    if (!qtyInput) return;
    qtyInput.value = singleQuantity;
    var card = qtyInput.closest('.ps-v2-single-card');
    if (!card) return;
    var priceEl = card.querySelector('.ps-v2-single__price');
    if (priceEl) priceEl.textContent = '$' + (singleBasePrice * singleQuantity).toFixed(2);
    var entriesAmountEl = card.querySelector('.ps-v2-single__entries-amount');
    if (entriesAmountEl) entriesAmountEl.textContent = singleBaseEntries * singleQuantity;
    var entriesTextEl = card.querySelector('.ps-v2-single__entries-text');
    if (entriesTextEl) {
      var total = singleBaseEntries * singleQuantity;
      var isSpanish = window.location.pathname.indexOf('fb-es') >= 0 || window.location.pathname.indexOf('fbpes') >= 0;
      entriesTextEl.textContent = total === 1
        ? (isSpanish ? 'Boleto' : 'Ticket')
        : (isSpanish ? 'Boletos' : 'Tickets');
    }
  }

  if (minusBtn) {
    minusBtn.addEventListener('click', function () {
      if (singleQuantity > 1) {
        singleQuantity -= 1;
        updateSingleDisplay();
      }
    });
  }

  if (plusBtn) {
    plusBtn.addEventListener('click', function () {
      singleQuantity = enforceMax(singleQuantity + 1);
      updateSingleDisplay();
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var val = parseInt(qtyInput.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      val = enforceMax(val);
      singleQuantity = val;
      updateSingleDisplay();
    });
  }

  /* ---------- SINGLE TICKET – CARD CLICK → ADD TO CART ---------- */
  var singleCards = document.querySelectorAll('.ps-v2-single-card');
  singleCards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      // Don't trigger buy if interacting with quantity controls
      if (e.target.closest('.ps-v2-single__qty-controls')) return;
      e.preventDefault();
      if (card.classList.contains('sold-out')) return;
      addToCartV2(card, singleQuantity);
    });
  });

  /* ---------- SINGLE TICKET – BUY BUTTON ---------- */
  var singleBuyBtns = document.querySelectorAll('.ps-v2-buy-single');
  singleBuyBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('sold-out')) return;
      addToCartV2(btn, singleQuantity);
    });
  });

  /* ---------- UNLOCK MORE ENTRIES ---------- */
  function setupUnlock(btnId, extraId) {
    var btn = document.getElementById(btnId);
    var extra = document.getElementById(extraId);
    if (!btn || !extra) return;
    var iconLocked = btn.querySelector('.ps-v2-unlock__icon-locked');
    var iconUnlocked = btn.querySelector('.ps-v2-unlock__icon-unlocked');
    var textEl = btn.querySelector('.ps-v2-unlock__text');
    var isSpanish = window.location.pathname.indexOf('fb-es') >= 0 || window.location.pathname.indexOf('fbpes') >= 0;
    var lockedText = isSpanish ? 'Desbloquea más boletos' : 'Unlock More Tickets';
    var unlockedText = isSpanish ? 'Mostrar menos boletos' : 'Show Less Tickets';
    btn.addEventListener('click', function () {
      var opening = !extra.classList.contains('active');
      extra.classList.toggle('active');
      if (iconLocked) iconLocked.style.display = opening ? 'none' : '';
      if (iconUnlocked) iconUnlocked.style.display = opening ? '' : 'none';
      if (textEl) textEl.textContent = opening ? unlockedText : lockedText;
    });
  }
  // Card layout unlock
  setupUnlock('ps-v2-unlock-onetime-card', 'ps-v2-extra-onetime-card');
  // Table layout unlock
  setupUnlock('ps-v2-unlock-onetime-table', 'ps-v2-extra-onetime-table');

  /* ---------- PREMIUM SOUND ---------- */
  function playBuySound() {
    try {
      var ctx = new (window.AudioContext || window.webkitAudioContext)();
      var gain = ctx.createGain();
      gain.connect(ctx.destination);
      gain.gain.setValueAtTime(0.15, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.2);

      [880, 1320].forEach(function (freq) {
        var osc = ctx.createOscillator();
        osc.type = 'sine';
        osc.frequency.value = freq;
        osc.connect(gain);
        osc.start(ctx.currentTime);
        osc.stop(ctx.currentTime + 0.2);
      });

      setTimeout(function () { ctx.close(); }, 300);
    } catch (e) { /* AudioContext unavailable — silent fallback */ }
  }

  /* ---------- REWARD EFFECTS ---------- */
  function spawnParticles(el) {
    var rect = el.getBoundingClientRect();
    var cx = rect.left + rect.width / 2;
    var cy = rect.top + rect.height / 2;

    // Shockwave ring
    var ring = document.createElement('span');
    ring.className = 'ps-v2-shockwave';
    var ringSize = Math.max(rect.width, rect.height) * 2.2;
    ring.style.cssText =
      'left:' + cx + 'px;top:' + cy + 'px;' +
      'width:' + ringSize + 'px;height:' + ringSize + 'px;';
    document.body.appendChild(ring);
    setTimeout(function () { ring.remove(); }, 800);

    // Gold border-trace — racing arc around element perimeter
    var trace = document.createElement('span');
    trace.className = 'ps-v2-border-trace';
    el.appendChild(trace);

    // Two-wave particle burst
    emitWave(cx, cy, 16, 45, 80, 0);
    setTimeout(function () { emitWave(cx, cy, 10, 70, 120, 0.15); }, 150);
  }

  function emitWave(cx, cy, count, minDist, maxDist, jitter) {
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('span');
      var angle = (Math.PI * 2 / count) * i + (Math.random() * 0.5 - 0.25);
      var dist = minDist + Math.random() * (maxDist - minDist);
      var size = 2 + Math.random() * 5;
      var dur = 0.55 + Math.random() * 0.35;
      var bright = Math.random() > 0.5;
      var bg = bright
        ? 'radial-gradient(circle,#fffbe6,#ffd814)'
        : 'radial-gradient(circle,#fff4a3,#ffaa00)';
      dot.style.cssText =
        'position:fixed;z-index:9999;pointer-events:none;border-radius:50%;' +
        'width:' + size + 'px;height:' + size + 'px;' +
        'left:' + cx + 'px;top:' + cy + 'px;' +
        'background:' + bg + ';' +
        'box-shadow:0 0 ' + (size + 2) + 'px ' + Math.round(size / 2) + 'px rgba(255,216,20,0.5);' +
        'opacity:1;' +
        'transform:translate(-50%,-50%) translate(0px,0px) scale(1);' +
        'transition:transform ' + dur + 's cubic-bezier(0.16,1,0.3,1),opacity ' + dur + 's ease;';
      document.body.appendChild(dot);
      dot.offsetWidth;
      var tx = Math.cos(angle) * dist;
      var ty = Math.sin(angle) * dist - (10 + Math.random() * 15);
      dot.style.transform = 'translate(-50%,-50%) translate(' + tx + 'px,' + ty + 'px) scale(0)';
      dot.style.opacity = '0';
      setTimeout(function (d) { d.remove(); }, (dur + 0.1) * 1000, dot);
    }
  }

  /* ---------- CLEANUP on any page restore ---------- */
  function cleanupBuyingState() {
    isAddingToCart = false;
    document.querySelectorAll('.ps-v2-buying').forEach(function (el) {
      el.classList.remove('ps-v2-buying');
    });
    document.querySelectorAll('.ps-v2-border-trace').forEach(function (b) { b.remove(); });
    // Restore button text
    document.querySelectorAll('[data-original-text]').forEach(function (btn) {
      btn.textContent = btn.dataset.originalText;
      delete btn.dataset.originalText;
    });
    // Remove lingering entry flash
    document.querySelectorAll('.ps-v2-entries-flash').forEach(function (el) {
      el.classList.remove('ps-v2-entries-flash');
    });
  }
  // Covers bfcache restore, soft navigations, and regular back
  window.addEventListener('pageshow', function () {
    cleanupBuyingState();
    // Re-render cart icon bubble with fresh HTML from Shopify
    fetch(window.Shopify.routes.root + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          bubble.innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('.shopify-section')
            .innerHTML;
        }
      })
      .catch(function () {});
  });

  /* ---------- INIT ON DOM READY ---------- */
  document.addEventListener('readystatechange', function () {
    updateCart();
    checkKlaviyoState();
    checkHeaderFooter();
    var groupsEl = document.querySelector('.ps-v2-groups[data-active-group]');
    var defaultGroup = groupsEl ? groupsEl.getAttribute('data-active-group') : 'one-time';
    togglePrizeGroups(defaultGroup);
  });
})();
